<template>
    <div class="modal fade modal-with-custom-content position-fixed" :id="modalId" tabindex="-1" role="dialog"
         :class="{
            'modal-with-custom-content--dark-background':blockClickOutside || darkBackground,
            'modal-with-custom-content--wider':makeWider,
         }"
         :aria-labelledby="modalId" aria-hidden="true"
         :data-keyboard="blockClickOutside ? 'false' : false"
         :data-backdrop="blockClickOutside ? 'static' : false"
         :style="`z-index:${zIndex || 999995}`"
    >
        <div class="modal-dialog modal-dialog-centered" role="document">

            <div class="modal-content">

                <div class="modal-header" v-if="$slots.header || !hideTopCloseButton">
                    <slot name="header"></slot>
                    <button type="button" class="close" aria-label="Close" v-if="!hideTopCloseButton" @click="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div
                     class="modal-body d-flex flex-column justify-content-center">

                    <div class="modal-custom-wrapper">
                        <slot></slot>
                    </div>

                    <button v-if="!hideBottomCloseButton" class="btn btn-outline-secondary mt-3" @click.prevent="closeModal">
                        {{ translate.home.close }}
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

const data = () => {
    return {
        $: {},
    }
}

function created() {
    if (typeof $ !== "undefined") {
        this.$ = $;
    }
}

function closeModal() {
    if (typeof this.$(`#${this.modalId}`).modal === "function") {
        this.$(`#${this.modalId}`).modal('hide');
        this.$emit('close');
    }
}

function showModal() {
    if (typeof this.$(`#${this.modalId}`).modal === "function") {
        this.$(`#${this.modalId}`).modal('show');
    } else {
        setTimeout(() => {
            this.showModal();
        }, 100)
    }
}

function mounted() {
    if (this.forceShowModal) {
        this.showModal();
    }
}

export default {
    data,
    created,
    mounted,
    computed: {
        ...mapState(['translate'])
    },
    props: ['modalId', 'hideTopCloseButton', 'hideBottomCloseButton', 'forceShowModal', 'blockClickOutside', 'makeWider', 'darkBackground', 'addEmergencyMeetingModal', 'zIndex'],
    beforeDestroy() {
        window.clearModalFade();
    },
    methods: {
        closeModal,
        showModal,
    },
};
</script>
